import { useEffect } from "react";
import { useSocketContext } from "./socketProvider";

export const useSocketEvent = (event: string, handler: any) => {
  const { socket } = useSocketContext();

  useEffect(() => {
    if (!socket) return;
    socket.on(event, handler);
    return () => {
      socket.off(event, handler);
    };
  }, [event, handler, socket]);
};
